module.exports = __webpack_public_path__ + "static/media/place-1.b69d2c5e.webp";